import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-objectives', templateUrl: './objectives.component.html', styleUrls: ['./objectives.component.scss'] })
export class ObjectivesComponent implements OnInit { constructor() { } ngOnInit(): void { } }
